import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('tmis_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const message = String(err.response?.data?.message || '').toLowerCase();
    const isTokenError = status === 401 || (status === 403 && message === 'invalid token.');
    const isLoginRequest = String(err.config?.url || '').includes('/api/auth/login');

    if (isTokenError && !isLoginRequest && window.location.pathname !== '/') {
      localStorage.removeItem('tmis_token');
      window.location.replace('/?auth_error=' + encodeURIComponent('Your session has expired. Please log in again.'));
    }
    return Promise.reject(err);
  }
);

export default api;
